import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ref as dbRef, get, update } from 'firebase/database';
import { database } from '../../Firebase/firebaseconfig';
import { ArrowLeft, Save } from 'lucide-react';
import './admin-page.css';

const FIELDS = [
  { key: 'Name',      label: 'Product Name' },
  { key: 'Price',     label: 'Price (₹)', type: 'number' },
  { key: 'Processor', label: 'Processor' },
  { key: 'Ram',       label: 'RAM' },
  { key: 'Storage',   label: 'Storage' },
  { key: 'Display',   label: 'Display' },
  { key: 'GPU',       label: 'GPU' },
  { key: 'OS',        label: 'Operating System' },
];

export default function EditDesktopDetails() {
  const { desktopKey } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    get(dbRef(database, `desktop_build/${desktopKey}`))
      .then(snap => {
        if (snap.exists()) setForm(snap.val());
        else setError('Desktop not found.');
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [desktopKey]);

  const handleSave = async (e) => {
    e.preventDefault();
    if (!form.Name || !form.Price) return setError('Name and Price are required.');
    setError(''); setSuccess(''); setSaving(true);
    try {
      await update(dbRef(database, `desktop_build/${desktopKey}`), {
        ...form,
        Price: Number(form.Price),
      });
      setSuccess('Desktop updated successfully!');
    } catch (err) {
      setError('Save failed: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="ap-loading">Loading…</div>;

  return (
    <div className="ap-page">
      <div className="ap-header">
        <button className="ap-back-btn" onClick={() => navigate('/admin/dashboard/edit-desktop')}><ArrowLeft size={18} /></button>
        <div>
          <h1 className="ap-title">Edit Desktop Details</h1>
          <p className="ap-subtitle">{form.Name}</p>
        </div>
      </div>

      {error && <div className="ap-error">{error}</div>}
      {success && <div className="ap-success">{success}</div>}

      <div className="ap-card">
        <form onSubmit={handleSave}>
          <div className="ap-row">
            {FIELDS.map(f => (
              <div className="ap-form-group" key={f.key}>
                <label className="ap-label">{f.label}</label>
                <input
                  className="ap-input"
                  type={f.type || 'text'}
                  value={form[f.key] || ''}
                  onChange={e => setForm(prev => ({ ...prev, [f.key]: e.target.value }))}
                />
              </div>
            ))}
          </div>
          <div className="ap-btn-row">
            <button type="submit" className="ap-btn ap-btn-primary" disabled={saving} style={{ display:'flex', alignItems:'center', gap:6 }}>
              <Save size={15} /> {saving ? 'Saving…' : 'Save Changes'}
            </button>
            <button type="button" className="ap-btn ap-btn-ghost" onClick={() => navigate('/admin/dashboard/edit-desktop')}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}
